<div class="test" [class.disabled]="isLoading">
    <div class="absolute">
        <div class="container">
            <div class="row">
                <div class="col-md-6 mx-auto text-center">
                    <img class="imgformat" src="assets/img/Group 39.png" style="justify-items: center" />
                </div>
            </div>
            <div class="row">
                <div class="col pt-3">
                    <h1 class="text-center">Reset Your Password</h1>
                </div>
            </div>


            <div class="row pr-3">
                <div class="col pt-3">
                    <form #rForm="ngForm" (ngSubmit)="onSubmit(rForm)">

                        <div class="form-group">

                            <label>New Password</label>
                            <input type="password" name="newpassword"  pattern="^(?=.*[@$!%*?&])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$" #newpassword="ngModel"
                                [(ngModel)]="resetData.newpassword" class="form-control text-white"
                                style="background-color: transparent" required />
                                <p *ngIf="rForm.submitted && rForm.controls['newpassword'].hasError('required')"
                                class="text-danger mb-0" style="font-size: 15px">
                                  New Password is required.
                                  </p>
                                  <p *ngIf="newpassword.touched && newpassword.errors && newpassword.errors.pattern" class="text-danger" style="font-size: 15px">
                                    Password must contain at least one special character, one lowercase letter, one uppercase letter, and
                                    one digit
                                  </p>
                            

                        </div>

                        <div class="form-group">
                            <label>Confirm Password</label>
                            <input type="password" name="confirmpassword" ngValidateEqual="newpassword"
                                #confirmpassword="ngModel" [(ngModel)]="resetData.confirmpassword"
                                class="form-control text-white" style="background-color: transparent" required />
                                <p *ngIf="rForm.submitted && rForm.controls['confirmpassword'].hasError('required')"
                                class="text-danger mb-0" style="font-size: 15px">
                                Confirm Password is required.
                              </p>
                            <p *ngIf="confirmpassword.hasError('notEqual')" class="text-danger"
                                style="font-size: 12px; font-family: Poppins;">
                                *Passwords Don't Match
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-12 pt-2 d-flex justify-content-center">
                                <button class="text-white btn" type="submit">
                                    Reset Password
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>